import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { ContentService } from '../../Services';
import { FaqWidget, IFaqItem } from '../Faq/FaqWidget';

interface IFaqListWidgetProps {
    currentFaqId: number | undefined;
    faqs: IFaqItem[];
    opinionLabel: string;
    opinionVotedLabel: string;
    dictNoResultTitle: string;
    dictNoResultDescription: string;
    showNoResult: boolean;
    isLoading: boolean;
    dictYes: string;
    dictNo: string;
    dictCommentSuccess: string;
    dictCommentFail: string;
    dictSend: string;
    dictCommentInvite: string;
    dictYourComment: string;
    contactUrl: string;
    contactString: string;
}

interface IFaqListWidgetState {
    currentOpenedFaq?: IFaqItem;
}

export class FaqListWidget extends Component<
    IFaqListWidgetProps,
    IFaqListWidgetState
> {
    constructor(props: IFaqListWidgetProps) {
        super(props);

        this.state = {
            currentOpenedFaq: undefined,
        };
    }

    async addHit(faq: IFaqItem) {
        try {
            await ContentService.addHit(faq.id);
        } catch (e) {
            if (!(e instanceof DOMException) || e.name !== 'AbortError') {
                throw e;
            }
        }
    }

    setCurrentFaq = (faq?: IFaqItem) => {
        if (faq === this.state.currentOpenedFaq) {
            this.setState({
                currentOpenedFaq: undefined,
            });

            return;
        }

        if (faq) {
            void this.addHit(faq);
        }

        this.setState({
            currentOpenedFaq: faq,
        });
    };

    render() {
        let currentFaq: IFaqItem | undefined;

        if (!this.state.currentOpenedFaq && this.props.currentFaqId) {
            currentFaq = this.props.faqs.find(
                (faq) => faq.id === Number(this.props.currentFaqId)
            );
        } else {
            currentFaq = this.state.currentOpenedFaq;
        }

        let faqs: JSX.Element;

        if (this.props.faqs.length === 0 && this.props.showNoResult) {
            if (!this.props.isLoading) {
                faqs = (
                    <div className="empty-state">
                        <i className="icon-no-results"></i>

                        <p>
                            <b>{this.props.dictNoResultTitle}</b>
                        </p>

                        <p>{this.props.dictNoResultDescription}</p>
                    </div>
                );
            } else {
                faqs = <></>;
            }
        } else {
            faqs = (
                <ul className="faq">
                    {this.props.faqs.map((faq) => (
                        <FaqWidget
                            key={faq.id}
                            faq={faq}
                            isOpen={faq === currentFaq}
                            onClick={this.setCurrentFaq}
                            opinionLabel={this.props.opinionLabel}
                            opinionVotedLabel={this.props.opinionVotedLabel}
                            dictSend={this.props.dictSend}
                            dictCommentSuccess={this.props.dictCommentSuccess}
                            dictCommentFail={this.props.dictCommentFail}
                            dictCommentInvite={this.props.dictCommentInvite}
                            dictYourComment={this.props.dictYourComment}
                            dictYes={this.props.dictYes}
                            dictNo={this.props.dictNo}
                            contactString={this.props.contactString}
                            contactUrl={this.props.contactUrl}
                        />
                    ))}
                </ul>
            );
        }

        return (
            <div className="faq-bloc faq-bloc--page">
                {this.props.isLoading && (
                    <div className="lds-ripple">
                        <div></div>
                        <div></div>
                    </div>
                )}

                {faqs}
            </div>
        );
    }
}

WidgetHelper.register(FaqListWidget, 'faq-list-widget');
